import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { CalculationParameterType } from '@/stores/type/calculationParameter.type'
import { useBaseStore } from '@haskoning/vue-basestore'

import { useApi } from '@/api/useApi'
import API from '@/api/apiUrls'

const api = useApi<CalculationParameterType>()

const baseUrl = API.CORE.CALCULATION_PARAMETERS

export const useCalculationParameterStore = defineStore('calculationParameter', () => {
	const baseStore = useBaseStore<CalculationParameterType>({ service: baseUrl, api })

	const filterFields = ref<string[]>(['name'])

	return {
		...baseStore,
		filterFields
	}
})
